import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box, Button } from '@mui/material';

import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import TelegramIcon from '@mui/icons-material/Telegram';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube'
import TikTokIcon from './TikTokIcon';




import { useLanguage } from '../../context/LanguageContext';

import { Container, GridChild, GridContainer, Logo, Title, useVisitCounter } from 'common';

export const Footer = () => {
    const visitCount = useVisitCounter();
    const { language } = useLanguage();

    const viewCountLabels = {
        ru: 'Просмотров страницы:',
        en: 'Page views:',
        kz: 'Бет қаралымдары:'
    };

    const contactLabels = {
        ru: {
            contacts: 'Контакты',
            address: 'Адрес: ул. Розыбакиева, д. 227 050060, Алматы, Казахстан',
            phone: '+7 (727) 313 29 55',
            email: 'lib@almau.edu.kz',
            telegram: 'Телеграм',
            instagram: 'Инстаграм',
            whatsapp: 'WhatsApp',
            facebook: 'Facebook',
            youtube: 'YouTube',
            tiktok: 'TikTok'
        },
        en: {
            contacts: 'Contacts',
            address: 'Address: Rozybakiyeva St. 227 050060, Almaty, Kazakhstan',
            phone: '+7 (727) 313 29 55',
            email: 'lib@almau.edu.kz',
            telegram: 'Telegram',
            instagram: 'Instagram',
            whatsapp: 'WhatsApp',
            facebook: 'Facebook',
            youtube: 'YouTube',
            tiktok: 'TikTok'
        },
        kz: {
            contacts: 'Байланыс',
            address: 'Мекен-жайы: Розыбакиева к., 227 050060, Алматы, Қазақстан',
            phone: '+7 (727) 313 29 55',
            email: 'lib@almau.edu.kz',
            telegram: 'Телеграм',
            instagram: 'Инстаграм',
            whatsapp: 'WhatsApp',
            facebook: 'Facebook',
            youtube: 'YouTube',
            tiktok: 'TikTok'

        }
    };

    const viewCountText = viewCountLabels[language];
    const labels = contactLabels[language];

    return (
        <footer>
            <Box
                sx={{
                    backgroundColor: '#404040',
                    paddingY: 4
                }}
            >
                <Container maxWidth="xl">
                    <GridContainer
                        sx={{
                            display: 'flex',
                            alignItems: 'flex-start',
                        }}
                    >
                        <GridChild >
                            <Box>
                                <Logo />
                                <Box sx={{ display: 'flex', alignItems: 'center', marginTop: 2, marginLeft: 2 }}>
                                    <Title sx={{ color: '#F8F8F8', marginRight: 1 }}>
                                        {viewCountText} {visitCount}
                                    </Title>
                                    <VisibilityIcon sx={{ color: '#F8F8F8' }} />
                                </Box>
                            </Box>
                        </GridChild>

                        <GridChild >
                            <Title sx={{ color: '#F8F8F8', fontWeight: 600 }} variant="h5">
                                {labels.contacts}
                            </Title>

                            <Title sx={{ fontWeight: 500, color: '#fff' }}>
                                    {labels.address}
                            </Title>

                            <Box
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: {
                                        xs: 'repeat(2, 1fr)', 
                                        sm: 'repeat(3, 1fr)', 
                                    }, 
                                    gap: 2, 
                                    marginTop: 2,
                                }}
                            >
                                <Button
                                    href="tel:+77273132955"
                                    color="error"
                                    variant="contained"
                                    startIcon={<PhoneIcon />}
                                >
                                    <Title sx={{ fontWeight: 500, color: '#fff' }}>
                                        {labels.phone}
                                    </Title>
                                </Button>

                                <Button
                                    href="mailto:lib@almau.edu.kz"
                                    color="error"
                                    variant="contained"
                                    startIcon={<EmailIcon />}
                                >
                                    <Title sx={{ fontWeight: 500, color: '#fff' }}>
                                        lib@almau.edu.kz
                                    </Title>
                                </Button>

                                <Button
                                    href="https://t.me/ALMAULIBRARY"
                                    color="error"
                                    variant="contained"
                                    startIcon={<TelegramIcon />}
                                >
                                    {labels.telegram}
                                </Button>

                                <Button
                                    href="https://www.instagram.com/almau_library/"
                                    color="error"
                                    variant="contained"
                                    startIcon={<InstagramIcon />}
                                >
                                    {labels.instagram}
                                </Button>

                                <Button
                                    href="https://chat.whatsapp.com/IaZXmlheAUcIaSW8bFtXy8"
                                    color="error"
                                    variant="contained"
                                    startIcon={<WhatsAppIcon />}
                                >
                                    {labels.whatsapp}
                                </Button>
                                <Button
                                    href="https://www.facebook.com/profile.php?id=61559059259759&mibextid=LQQJ4d"
                                    color="error"
                                    variant="contained"
                                    startIcon={<FacebookIcon />}
                                >
                                    {labels.facebook}
                                </Button>

                                <Button
                                    href="https://www.youtube.com/channel/UCSg_sZFS-b-FgxQuX7BMkZw"
                                    color="error"
                                    variant="contained"
                                    startIcon={<YouTubeIcon />}
                                >
                                    {labels.youtube}
                                </Button>

                                <Button
                                    href="https://www.tiktok.com/@almau_open_library?ysclid=m7txucrib081922738"
                                    color="error"
                                    variant="contained"
                                    startIcon={<TikTokIcon  fontSize="large" />}
                                >
                                    {labels.tiktok}
                                </Button>
                            </Box>
                        </GridChild>

                              
                    </GridContainer>
                </Container>
            </Box>
        </footer>
    );
};